const ENIndicatorModal = {
	"Ao menos um campo deve estar marcado para comparar com a meta":"At least one field must be marked to compare with goal",
	"Anos anteriores":"Previous years",
	"Código para integração":"Integration code",
	"Quantidade de anos anteriores que o sistema deve acumular nos gráficos e no painel": "Quantity of previous years that must be acummulated by the system on charts and panel",
	"Indicador adicionado com sucesso":"Indicator successfully added",
	"Indicador alterado com sucesso":"Indicator successfully changed",
	"Adicionar indicador": "Add indicator",
	"Copiar indicador":"Copy indicator",
	"Alterar indicador":"Change indicator",
	"Erro ao adicionar indicador":"Error on add indicator",
	"Erro ao alterar indicador":"Error on change indicator",
	"Erro ao encontrar indicador":"Error on find indicator",
	"Ver cadastro completo":"Use complete form",
	"Ver cadastro simplificado":"Use simple form",
	"Melhor para cima":"Best to up",
	"Melhor para baixo":"Best to down",
	"Ocultar avaliação":"Hide evaluation",
	"Ocultar indicador da forma de avaliação (Melhor pra cima/Melhor para baixo) nos gráficos" :"Hide evaluation method indicator (Best to up/Best to down) on charts",
	"Meta melhoria":"Improvement goal",
	"Meta padrão":"Default goal",
	"Os campos nos indicadores devem ser utilizados para inserção dos valores relacionados ao indicador":"The fields in the indicators must be used to insert values relationed to the indicator",
	"Valor de Faturamento no indicador de Faturamento mensal":"Income value in the monthly income indicator",
	"Adicionar campo":"Add field",
	"Adicionar campo avançado": "Add advanced field",
	"Criar novo campo":"Create new Field",
	"Comparar com meta":"Compare with goal",
	"Alterar campo":"Change field",
	"Remover campo":"Remove field",
	"Tipo de gráfico":"Graphic type",
	"Tipo de gráfico acumulador":"Accumulator chart type",
	"Eixo Y":"Axis Y",
	"Cores gráfico":"Chart colors",
	"Mostrar gráfico":"Show chart",
	"Mostrar gráfico acumulador":"Show accumulator chart",
	"Mostrar valor no gráfico":"Show value on chart",
	"Mostrar valor gráfico": "Show value on chart",
	"Mostrar em tabela":"Show in table",
	"Utilizar Campos Base":"Use base fields",
	"Conforme métricas":"According to metrics",
	"Conforme legenda":"According to subtitle",
	"Eixo Y direita":"Rigth axis Y",
	"Eixo Y esquerda":"Left axis Y",
	"Escala mín.":"Min. scale",
	"Escala max.":"Max. scale",
	"Linha de tendência":"Tendency line",
	"Na tab de campos você pode configurar se o campo será do eixo Y da esquerda ou direita":"On fields tab, the field can be configured to be left or right in axis Y",
	"Orientação valores no gráfico":"Chart values orientation",
	"Composição":"Composition",
	"Calcular acumulados":"Calculate acumulated",
	"Verifica análise crítica":"Verify critical analysis",
	"Verifica ausência de Análise Crítica de acordo com parâmetro 5 dos Indicadores e apresenta alerta no painel":
	"Verify critical analysis absence in line with parameter 5 of indicators e shows an alert in the panel ",
	"Defina as opções de visualização do gráfico":"Define the chart visualization options",
	"As faixas das métricas são utilizadas para colorir os períodos no painel de indicadores, informe os limites percentuais para cada faixa":
	"Metric's ranges are used to colorize the periods on indicators panel, inform the percentual limit for each range",
	"Deve ser usado como valor referencial comparativo, pode ser um concorrente ou a média do setor em que a empresa atua":
	"Should be used like a comparative reference value, can be a competitor or a sector average that our business act",
	"Deve ser usado como valor referencial pelas partes interessadas":"Should be used like a referencial value by the interested parts",
	"Colocar a meta que o sócio quer, por exemplo, 25% de lucro para o próximo ano": "Put your partner goal, for example, profit of 25% for the next year",
	"Usar meta competitividade":"Use competitiveness goal",
	"Usar meta compromisso":"Use compromisse goal",
	"Meta competitividade":"Competitiveness goal",
	"Meta compromisso":"Compromisse goal",
	"Visual nos gráficos":"Graphics look",
	"Tipo de acumulador":"Accumulator type",
	"Insira os dados de competitividade":"Insert competitiveness data",
	"Insira os dados de compromisso":"Insert compromisse data",
	"Ao menos um campo deve ser informado":"At least one field must be included",
	"Campos não podem ser repetidos":"Fields can´t be repeated",
	"O código é obrigatório":"Code is required",
	"Campo é requerido":"Field is required",
	"Campo está com valor incorreto":"Field's value is wrong",
	"O tipo de período é obrigatório":"Period's type is required",
	"O tipo de período está com valor incorreto":"Period's type value is wrong",
	"O responsável é obrigatório":"Responsible is required",
	"Meta padrão é obrigatoria":"Default goal is required",
	"Opção de permissão é requerida":"Permission option is required",
	"Grupo de usuário é requerido":"User's group is required",
	"Opção invalida":"Invalid option",
	"Períodos para cálculo":"Periods calculation",
	"Indica como o indicador irá calcular o valor acumulado. Se só irá considerar os períodos que estejam encerrados, todos os períodos até a data atual ou todos os períodos do ano base":
	"Indicates how the indicator will valculate the Accumulated value. If will consider only closed periods, all periods until the actual date or all periods on the base year",
	"Somente períodos fechados":"Only closed periods",
	"Selecione um campo para editá-lo": "Select a field to edit it",
	"Períodos fechados ou iniciados":"Closed or started periods",
	"Todos períodos do ano base":"All periods on base year",
	"Casas decimais painel": "Panel Decimals",
	"Ordenar as metas": "Sort goals"
};

export default ENIndicatorModal;
